import { Component, OnInit, ViewChild, Optional, ViewContainerRef } from '@angular/core';
import { AutoTradeHistoryService } from '../../_services/auto-trade-history.service';
import { CoinConfigService} from '../../_services/coinconfig.service';
import { Observable } from 'rxjs/Observable';
import { AsyncPipe } from '@angular/common';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'auto-trade-history',
    templateUrl: './auto-trade-history.component.html',
    styleUrls: ['./auto-trade-history.component.css']
})
export class AutoTradeHistoryComponent implements OnInit {

    model: any = {};
    pairs: Observable<any[]>;
    dataPairs: any[] = [];
    objectPairs: any = {};
    pair: string;

    coinName: string;
    delayTimer: any;
    dtTrigger: Subject<any> = new Subject();
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;

    //declare parameters object
    parameters: any = {};
    //declare callback object
    callback: any = {};
    isRoleUser: any;

    totalProfit: number;
    totalProfitAmount: number;

    timeSelect = [
        { id: 1, des: '1日' },
        { id: 2, des: '7日' },
        { id: 3, des: '1月' },
        { id: 4, des: '3月' },
        { id: 5, des: '1年' },
        { id: 6, des: 'すべて' }
    ];

    filterBy = 6; // default load 

    constructor(
        private autoTradeHistoryService: AutoTradeHistoryService,
        private coinConfigService: CoinConfigService,
    ) { }

    ngOnInit() {

        this.registerTable();

        //pairs
        this.pairs = this.coinConfigService.getPairs();
        this.pairs.subscribe(data => {
            this.dataPairs = data;
            data.forEach(element => {
                this.objectPairs[element.id] = element.name;
            });
            this.dtTrigger.next();
        });

    }

    registerTable() {
        let self = this;
        var jsonColumn = [
            {
                title: "コイン名",
                data: "coin_name",
                name: "coin_name",
                className: "all text-justify"
            },
            {
                title: "コイン市場名",
                data: "pair",
                name: "pair",
                className: "all text-justify"
            },
            {
                title: "買いの価格",
                data: "buy_price",
                name: "buy_price",
                className: "text-justify"
            },
            {
                title: "買いの時刻",
                data: "buy_time",
                name: "buy_time",
                className: "text-justify"
            },
            {
                title: "売りの価格",
                data: "sell_price",
                width: '60px',
                className: "all text-center",
            },
            {
                title: "売りの時刻",
                data: "sell_time",
                width: '60px',
                className: "all text-center",
            },
            {
                title: "数量",
                data: "amount",
                width: '60px',
                className: "all text-center",
            },
            {
                title: "利益(%)",
                data: "amount",
                width: '60px',
                className: "all text-center profit",
            }
        ];

        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.coinName || '';
                parameters["search"]["pair"] = self.pair || '';
                parameters["search"]["date"] = self.filterBy;

                self.totalProfit = 0;
                //assign parameters object
                self.parameters = parameters;

                //assign callback object
                self.callback = callback;

                self.autoTradeHistoryService.gets(parameters).subscribe(result => {
                    callback({
                        draw: parameters['draw'],
                        data: result.data,
                        recordsTotal: result.data.length,
                        recordsFiltered: result.recordsTotal
                    });
                });
            },
            columns: jsonColumn,
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                const self = this;
                let profit = (data['sell_price']-data['buy_price'])*100/data['buy_price'];
                let profitColor = profit >= 0 ? 'green' : 'red';
                $(row).find('.profit').css({ 'color': profitColor });
                $(row).find('.profit').html(profit.toFixed(8));

                self.totalProfit += profit;
                let totalProfitColor = self.totalProfit >= 0 ? 'green' : 'red';
                return row;
            }
        };
    }

    onChange(event) {
        this.pair = event.target.value;
        this.rerenderDataTable();
    }

    valuechange(newValue) {
        this.coinName = newValue;
        this.doSearch();
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.rerenderDataTable();
        }, 600); // Will do the ajax stuff aft
    };

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page 
        this.autoTradeHistoryService.gets(this.parameters).subscribe(result => {
            //use callback function
            this.callback({
                //retrive draw current
                draw: this.parameters['draw'],
                //retrive data of current page
                data: result.data,
                //retrive number records per page
                recordsTotal: result.data.length,
                //retrive total records
                recordsFiltered: result.recordsTotal
            });
        });
    }

    filterBydate(event) {
        this.filterBy = event.currentTarget.attributes.data.nodeValue;
        this.rerenderDataTable();
    }

    filterNextTime() {
        if (this.filterBy < 6) {
            this.filterBy++;
            this.rerenderDataTable();
        }
    }

    filterPreTime() {
        if (this.filterBy > 1) {
            this.filterBy--;
            this.rerenderDataTable();
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/auto-trade-history/auto-trade-history.component.ts